import React, { useRef, useState, useEffect, useCallback } from 'react';
import Modal from 'react-bootstrap/Modal';
import { Mensaje } from '../../mensajes';
import { Dimmer } from "../../spinner";
import axios from "axios";

export const ImpListadoSolicitudLicencia = (props) => {
    let token = localStorage.getItem("jwtToken");
    let op = require('../../../../src/modulos/datos');

    // ============ REFERENCIAS ============
    const btnAcepta = useRef();
    const btnCancela = useRef();
    const btnSalir = useRef();
    const txtDesdeFech = useRef();
    const txtHastaFech = useRef();
    const cmbAnio = useRef();

    // ============ ESTADOS ============
    const [mensaje, setMensaje] = useState({
        mostrar: false,
        titulo: "",
        texto: "",
        icono: "",
    });
    const [activate, setActivate] = useState(false);
    const [radioTodasFecha, setRadioTodasFecha] = useState(true);
    const [radioPorFecha, setRadioPorFecha] = useState(false);
    const [desdeFecha, setDesdeFecha] = useState('');
    const [hastaFecha, setHastaFecha] = useState('');
    const [anios, setAnios] = useState([]);
    const [selectedAnio, setSelectedAnio] = useState('');

    // ============ FUNCIONES AUXILIARES ============

    // Obtener el título según el tipo de reporte
    const getTitulo = () => {
        if (props.tabla === 111) {
            return "Listado General de Solicitudes de Licencias";
        } else if (props.tabla === 112) {
            return "Listado General de Solicitudes de Renovación de Licencias";
        } else if (props.tabla === 113) {
            return "Listado de Actividades Económicas";
        }
        return "Listado General de Solicitudes";
    };

    // Obtener el subtítulo según el tipo de reporte
    const getSubtitulo = () => {
        if (props.tabla === 111) {
            return "Impresión de Listado General de Solicitudes de Licencias";
        } else if (props.tabla === 112) {
            return "Impresión de Listado General de Solicitudes de Renovación de Licencias";
        } else if (props.tabla === 113) {
            return "Impresión de Listado de Actividades Económicas";
        }
        return "Impresión de Listado General de Solicitudes";
    };

    // Obtener el nombre del reporte según el tipo
    const getNombreReporte = () => {
        if (props.tabla === 111) {
            return "ListSolicitudLicencia";
        } else if (props.tabla === 112) {
            return "ListSolicitudRenovacion";
        } else if (props.tabla === 113) {
            return "ClasificadorActividades";
        }
        return "ListSolicitudLicencia";
    };

    // Obtener años disponibles (últimos 7 años hasta el actual)
    const obtenerAnios = () => {
        try {
            const post = JSON.parse(localStorage.getItem('post') || '{}');
            const anioActual = parseInt(post.anioactu) || new Date().getFullYear();
            const anioInicio = anioActual - 7;
            const aniosDisponibles = [];
            
            for (let i = anioInicio; i <= anioActual; i++) {
                aniosDisponibles.push(i);
            }
            return aniosDisponibles.reverse();
        } catch (error) {
            console.error('Error obteniendo años:', error);
            const anioActual = new Date().getFullYear();
            const aniosDisponibles = [];
            for (let i = anioActual - 7; i <= anioActual; i++) {
                aniosDisponibles.push(i);
            }
            return aniosDisponibles.reverse();
        }
    };

    // Formatea una fecha ISO (YYYY-MM-DDThh:mm:ss.sssZ) a DD/MM/YYYY
    const formatearFechaISO = (fechaISO) => {
        if (!fechaISO) return '';

        if (/^\d{2}\/\d{2}\/\d{4}$/.test(fechaISO)) {
            return fechaISO;
        }

        try {
            let fechaStr = fechaISO;
            if (fechaISO.includes('T')) {
                fechaStr = fechaISO.split('T')[0];
            }

            const parts = fechaStr.split('-');
            if (parts.length === 3) {
                return `${parts[2]}/${parts[1]}/${parts[0]}`;
            }
            return '';
        } catch (error) {
            console.error('Error formateando fecha:', error);
            return '';
        }
    };

    // Obtiene la fecha actual del sistema desde localStorage
    const obtenerFechaSistema = () => {
        try {
            const post = JSON.parse(localStorage.getItem('post') || '{}');
            if (post.fechasistema) {
                return formatearFechaISO(post.fechasistema);
            }

            const hoy = new Date();
            const dia = String(hoy.getDate()).padStart(2, '0');
            const mes = String(hoy.getMonth() + 1).padStart(2, '0');
            const anio = hoy.getFullYear();
            return `${dia}/${mes}/${anio}`;
        } catch (error) {
            console.error('Error obteniendo fecha sistema:', error);
            const hoy = new Date();
            const dia = String(hoy.getDate()).padStart(2, '0');
            const mes = String(hoy.getMonth() + 1).padStart(2, '0');
            const anio = hoy.getFullYear();
            return `${dia}/${mes}/${anio}`;
        }
    };

    // Valida que la fecha tenga formato DD/MM/YYYY
    const esFechaValida = (fecha) => {
        if (!fecha) return false;

        const regex = /^(\d{2})\/(\d{2})\/(\d{4})$/;
        if (!regex.test(fecha)) return false;

        const parts = fecha.split('/');
        const day = parseInt(parts[0], 10);
        const month = parseInt(parts[1], 10);
        const year = parseInt(parts[2], 10);

        if (month < 1 || month > 12) return false;

        const daysInMonth = new Date(year, month, 0).getDate();
        if (day < 1 || day > daysInMonth) return false;

        return true;
    };

    // Convierte DD/MM/YYYY a YYYY-MM-DD para la BD
    const fechaToISO = (fecha) => {
        if (!fecha) return '';
        const parts = fecha.split('/');
        if (parts.length !== 3) return fecha;
        return `${parts[2]}-${parts[1]}-${parts[0]}`;
    };

    // Valida que fechaDesde sea menor o igual a fechaHasta
    const validarRangoFechas = (desde, hasta) => {
        if (!desde || !hasta) return true;
        if (!esFechaValida(desde) || !esFechaValida(hasta)) return false;

        const partsDesde = desde.split('/');
        const partsHasta = hasta.split('/');

        const dateDesde = new Date(partsDesde[2], parseInt(partsDesde[1]) - 1, partsDesde[0]);
        const dateHasta = new Date(partsHasta[2], parseInt(partsHasta[1]) - 1, partsHasta[0]);

        return dateDesde <= dateHasta;
    };

    // Formatea mientras escribe: solo números y agrega barras automáticamente
    const formatearFechaInput = (value) => {
        let cleaned = value.replace(/\D/g, '');
        if (cleaned.length > 8) cleaned = cleaned.slice(0, 8);

        let formatted = '';
        if (cleaned.length > 0) {
            formatted = cleaned.slice(0, 2);
            if (cleaned.length >= 3) formatted += '/' + cleaned.slice(2, 4);
            if (cleaned.length >= 5) formatted += '/' + cleaned.slice(4, 8);
        }
        return formatted;
    };

    // Validar campos de fecha
    const validarCamposFecha = () => {
        if (!radioPorFecha) return true;

        if (!desdeFecha.trim()) {
            setMensaje({
                mostrar: true,
                titulo: 'ADVERTENCIA',
                texto: 'Debe introducir la fecha de inicio',
                icono: 'warning'
            });
            return false;
        }

        if (!hastaFecha.trim()) {
            setMensaje({
                mostrar: true,
                titulo: 'ADVERTENCIA',
                texto: 'Debe introducir la fecha de fin',
                icono: 'warning'
            });
            return false;
        }

        if (!esFechaValida(desdeFecha)) {
            setMensaje({
                mostrar: true,
                titulo: 'ADVERTENCIA',
                texto: 'Fecha de inicio inválida. Use formato DD/MM/AAAA',
                icono: 'warning'
            });
            return false;
        }

        if (!esFechaValida(hastaFecha)) {
            setMensaje({
                mostrar: true,
                titulo: 'ADVERTENCIA',
                texto: 'Fecha de fin inválida. Use formato DD/MM/AAAA',
                icono: 'warning'
            });
            return false;
        }

        if (!validarRangoFechas(desdeFecha, hastaFecha)) {
            setMensaje({
                mostrar: true,
                titulo: 'ADVERTENCIA',
                texto: 'La fecha de inicio no puede ser mayor que la fecha de fin',
                icono: 'warning'
            });
            return false;
        }

        return true;
    };

    // ============ GENERAR REPORTE ============
    const generarReporte = useCallback(async () => {
        // Para el tipo 113 (Actividades Económicas)
        if (props.tabla === 113) {
            if (!selectedAnio) {
                setMensaje({
                    mostrar: true,
                    titulo: 'ADVERTENCIA',
                    texto: 'Debe seleccionar un año',
                    icono: 'warning'
                });
                return;
            }
            
            setActivate(true);
            
            try {
                const endpoint = `${op.reportes}/actividadeconomica`;
                const params = {
                    reporte: getNombreReporte(),
                    ANIO: selectedAnio,
                    CONDICION: `actividad.anios = ${selectedAnio} AND actividad.actualizada = true`
                };
                
                window.open(
                    `${endpoint}?${new URLSearchParams(params).toString()}`,
                    getNombreReporte(),
                    "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
                );
                
            } catch (error) {
                console.error('Error:', error);
                setMensaje({
                    mostrar: true,
                    titulo: 'ERROR',
                    texto: error.response?.data?.message || 'Error al generar el reporte',
                    icono: 'error'
                });
            } finally {
                setActivate(false);
            }
            return;
        }
        
        // Para los tipos 111 y 112 (Solicitudes)
        if (!validarCamposFecha()) return;

        setActivate(true);

        try {
            let condicion = "";
            let tituloAdicional = "";

            if (radioTodasFecha) {
                condicion = "true";
                tituloAdicional = "Todas las Solicitudes";
            } else {
                const desdeFormat = fechaToISO(desdeFecha);
                const hastaFormat = fechaToISO(hastaFecha);
                condicion = `fechasolicitud BETWEEN '${desdeFormat}' AND '${hastaFormat}'`;
                tituloAdicional = `DESDE EL ${desdeFecha} HASTA EL ${hastaFecha}`;
            }

            const endpoint = `${op.reportes}/actividadeconomica`;
            const params = {
                reporte: getNombreReporte(),
                CONDICION: condicion,
                TIT_ADICIONAL: tituloAdicional
            };

            window.open(
                `${endpoint}?${new URLSearchParams(params).toString()}`,
                getNombreReporte(),
                "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
            );

        } catch (error) {
            console.error('Error:', error);
            setMensaje({
                mostrar: true,
                titulo: 'ERROR',
                texto: error.response?.data?.message || 'Error al generar el reporte',
                icono: 'error'
            });
        } finally {
            setActivate(false);
        }
    }, [radioTodasFecha, desdeFecha, hastaFecha, selectedAnio, op.reportes, props.tabla]);

    // ============ MANEJADORES ============
    const handleImprimir = () => generarReporte();

    const handleCancelar = () => {
        if (props.tabla === 113) {
            const aniosDisponibles = obtenerAnios();
            if (aniosDisponibles.length > 0) {
                setSelectedAnio(aniosDisponibles[0].toString());
            }
        } else {
            const fechaSistema = obtenerFechaSistema();
            setRadioTodasFecha(true);
            setRadioPorFecha(false);
            setDesdeFecha(fechaSistema);
            setHastaFecha(fechaSistema);
            if (txtDesdeFech.current) txtDesdeFech.current.value = fechaSistema;
            if (txtHastaFech.current) txtHastaFech.current.value = fechaSistema;
        }
    };

    const handleSalir = () => {
        props.setShow();
        if (props.setTabla) {
            props.setTabla(0);
        }
    };

    const handleRadioTodasFecha = () => {
        setRadioTodasFecha(true);
        setRadioPorFecha(false);
    };

    const handleRadioPorFecha = () => {
        setRadioTodasFecha(false);
        setRadioPorFecha(true);
    };

    const handleDesdeFechaChange = (e) => {
        const value = formatearFechaInput(e.target.value);
        setDesdeFecha(value);
        if (txtDesdeFech.current) txtDesdeFech.current.value = value;
    };

    const handleHastaFechaChange = (e) => {
        const value = formatearFechaInput(e.target.value);
        setHastaFecha(value);
        if (txtHastaFech.current) txtHastaFech.current.value = value;
    };

    const handleAnioChange = (e) => {
        setSelectedAnio(e.target.value);
    };

    // ============ EFECTO INICIAL ============
    useEffect(() => {
        if (props.tabla === 113) {
            const aniosDisponibles = obtenerAnios();
            setAnios(aniosDisponibles);
            if (aniosDisponibles.length > 0) {
                setSelectedAnio(aniosDisponibles[0].toString());
            }
        } else {
            const fechaSistema = obtenerFechaSistema();
            setDesdeFecha(fechaSistema);
            setHastaFecha(fechaSistema);
            if (txtDesdeFech.current) txtDesdeFech.current.value = fechaSistema;
            if (txtHastaFech.current) txtHastaFech.current.value = fechaSistema;
        }
    }, [props.tabla]);

    // ============ RENDER ============
    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            backdrop="static"
            keyboard={false}
        >
            <Modal.Header className="azulGradiant">
                <h5 className="mb-0">{getTitulo()}</h5>
                <button
                    className="btn btn-link text-white"
                    onClick={handleSalir}
                    style={{ border: 0, margin: 0, padding: 0 }}
                >
                    <i className="far fa-window-close fa-lg"></i>
                </button>
            </Modal.Header>

            <Modal.Body className="p-4">
                <div className="text-center mb-4">
                    <h6 className="fw-bold">{getSubtitulo()}</h6>
                </div>

                {/* Para los tipos 111 y 112 - Filtro por fecha */}
                {(props.tabla === 111 || props.tabla === 112) && (
                    <div className="card mb-4">
                        <div className="card-header bg-light">
                            <strong>Buscar por Fecha de Solicitud:</strong>
                        </div>
                        <div className="card-body">
                            <div className="row">
                                <div className="col-md-12 mb-3">
                                    <div className="form-check form-check-inline ml-5">
                                        <input
                                            type="radio"
                                            className="form-check-input"
                                            id="radioTodasFecha"
                                            name="filtroFecha"
                                            checked={radioTodasFecha}
                                            onChange={handleRadioTodasFecha}
                                        />
                                        <label className="form-check-label" htmlFor="radioTodasFecha">
                                            Todas las fechas
                                        </label>
                                    </div>
                                    <div className="form-check form-check-inline ml-5">
                                        <input
                                            type="radio"
                                            className="form-check-input"
                                            id="radioPorFecha"
                                            name="filtroFecha"
                                            checked={radioPorFecha}
                                            onChange={handleRadioPorFecha}
                                        />
                                        <label className="form-check-label" htmlFor="radioPorFecha">
                                            Por fecha
                                        </label>
                                    </div>
                                </div>
                            </div>

                            {radioPorFecha && (
                                <div className="row">
                                    <div className="col-md-5 mb-3">
                                        <label className="form-label fw-bold">Desde la Fecha:</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            ref={txtDesdeFech}
                                            value={desdeFecha}
                                            onChange={handleDesdeFechaChange}
                                            placeholder="DD/MM/AAAA"
                                            maxLength={10}
                                        />
                                        <small className="text-muted">Formato: DD/MM/AAAA</small>
                                    </div>
                                    <div className="col-md-5 mb-3">
                                        <label className="form-label fw-bold">Hasta la Fecha:</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            ref={txtHastaFech}
                                            value={hastaFecha}
                                            onChange={handleHastaFechaChange}
                                            placeholder="DD/MM/AAAA"
                                            maxLength={10}
                                        />
                                        <small className="text-muted">Formato: DD/MM/AAAA</small>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                )}

                {/* Para el tipo 113 - Selector de año */}
                {props.tabla === 113 && (
                    <div className="card mb-4">
                        <div className="card-header bg-light">
                            <strong>Seleccione el Año:</strong>
                        </div>
                        <div className="card-body">
                            <div className="row">
                                <div className="col-md-4 mb-3">
                                    <label className="form-label fw-bold">Año:</label>
                                    <select
                                        ref={cmbAnio}
                                        className="form-select form-select-sm"
                                        value={selectedAnio}
                                        onChange={handleAnioChange}
                                    >
                                        {anios.map(anio => (
                                            <option key={anio} value={anio.toString()}>
                                                {anio}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="col-md-8 mb-3">
                                    <div className="alert alert-info small mt-4">
                                        <i className="fas fa-info-circle me-2"></i>
                                        Seleccione el año para el cual desea ver el listado de actividades económicas.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* Mensaje informativo */}
                <div className="alert alert-info small">
                    <i className="fas fa-info-circle me-2"></i>
                    {props.tabla === 111 && (
                        <>Este reporte generará un listado con todas las solicitudes de licencia registradas.</>
                    )}
                    {props.tabla === 112 && (
                        <>Este reporte generará un listado con todas las solicitudes de renovación de licencia registradas.</>
                    )}
                    {props.tabla === 113 && (
                        <>Este reporte generará un listado con todas las actividades económicas registradas para el año <strong>{selectedAnio || 'seleccionado'}</strong>.</>
                    )}
                    {props.tabla !== 113 && radioPorFecha && desdeFecha && hastaFecha && (
                        <span> Filtrado desde <strong>{desdeFecha}</strong> hasta <strong>{hastaFecha}</strong>.</span>
                    )}
                </div>
            </Modal.Body>

            <Modal.Footer>
                <button
                    ref={btnAcepta}
                    onClick={handleImprimir}
                    className="btn btn-sm btn-primary rounded-pill px-4"
                    disabled={activate || (props.tabla === 113 && !selectedAnio)}
                >
                    <i className="fas fa-print me-1"></i> Imprimir
                </button>
                <button
                    ref={btnCancela}
                    onClick={handleCancelar}
                    className="btn btn-sm btn-secondary rounded-pill px-4"
                    disabled={activate}
                >
                    <i className="fas fa-eraser me-1"></i> Cancelar
                </button>
                <button
                    onClick={handleSalir}
                    className="btn btn-sm btn-danger rounded-pill px-4"
                >
                    <i className="fa fa-sign-out-alt me-1"></i> Salir
                </button>
            </Modal.Footer>

            {activate && <Dimmer />}

            {mensaje.mostrar && (
                <Mensaje
                    titulo={mensaje.titulo}
                    texto={mensaje.texto}
                    icono={mensaje.icono}
                    onAceptar={() => setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })}
                />
            )}
        </Modal>
    );
};

export default ImpListadoSolicitudLicencia;